import React, { useState } from "react";
import { IonFab, IonFabButton, IonIcon, IonPopover } from "@ionic/react";
import { languageOutline } from "ionicons/icons";
import LanguageHelpPopover from "./LanguageHelpPopover";
import "./FloatingLanguageButton.css";

const FloatingLanguageButton: React.FC = () => {
  const [popoverEvent, setPopoverEvent] = useState<Event | undefined>(undefined);
  const [isOpen, setIsOpen] = useState(false);

  const handleOpen = (event: React.MouseEvent<HTMLElement>) => {
    setPopoverEvent(event.nativeEvent);
    setIsOpen(true);
  };

  return (
    <>
      <IonFab
        slot="fixed"
        vertical="bottom"
        horizontal="end"
        className="floating-language-button"
      >
        <IonFabButton aria-label="Translate this page" onClick={handleOpen}>
          <IonIcon icon={languageOutline} />
        </IonFabButton>
      </IonFab>
      <IonPopover
        isOpen={isOpen}
        event={popoverEvent}
        onDidDismiss={() => setIsOpen(false)}
        className="language-help-popover"
      >
        <LanguageHelpPopover />
      </IonPopover>
    </>
  );
};

export default FloatingLanguageButton;
